import '@polymer/polymer/lib/elements/custom-style.js';
import '@polymer/polymer/lib/elements/dom-module.js';

const $_documentContainer = document.createElement('custom-style');
$_documentContainer.setAttribute('title', 'nirvana-ds-variables');

$_documentContainer.innerHTML = `
  <style>
    html {
      /* BASE SIZES */
      --spacer: 8px;
      --widget-border-radius: 3px;
      --input-border-radius: 4px;

      /* MENU HEIGHT */
      --menu-height: 54;

      --enum-filter-content-max-height: 310px;
      --single-select-list-content-max-height : 344px;

      /* BUTTONS SIZES*/
      --button-height: 32px;
      --small-button-height: 24px;
      --button-border-radius: 16px;
      --quiet-button-border-radius: 50px;

      /* LOADER VARIABLES */
      --loader-border-radius: 8px;
      --loader-height: 21px;
      --loader-gradient-angle: 270deg;

      /* TOOLTIP VARIABLES */
      --tooltip-border-radius: 4px;
      --tooltip-width: 200px;

      /* DIALOG VARIABLES */
      --dialog-close-button-size: 36px;

      /* INPUTS */
      --floating-label-transition: all 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
      --input-padding-top: calc(var(--spacer) * 1.1);
      --input-padding-left: calc(var(--spacer) * 1.5);
      --input-padding: var(--input-padding-top) 0 var(--spacer) var(--input-padding-left);
      --textarea-padding: var(--input-padding-top) var(--input-padding-left) var(--spacer) var(--input-padding-left);
      --dropdown-list-width: 240px;

      /* List item height */
      --list-item-height: 32;

      /* Loader animation */
      --animation: glow 2.5s infinite;

    }
  </style>
`;

document.head.appendChild($_documentContainer);
